import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, usePurchaseContractsDispatch } from "./purchase-contracts-context";
import { IListPurchaseContractsRequest } from "../../../model/base/request/list-purchase-contracts-request";

export const usePurchaseContractsController = () => {
    const PurchaseContractsDispatch = usePurchaseContractsDispatch();

    async function loadData(request: IListPurchaseContractsRequest) {
        try {
            // Limpa os dados antes de carregar novos
            PurchaseContractsDispatch({
                type: ACTION_TYPES.CLEAR_PURCHASE_CONTRACTS,
            });
            const result = await PortalAppService.requestPurchaseContracts(request);
            PurchaseContractsDispatch({
                type: ACTION_TYPES.SET_PURCHASE_CONTRACTS,
                payload: result,
            });
        } catch (error) {
            console.log(error);
        }
    }

    async function loadDetail(id: number) {
        try {
            const result = await PortalAppService.requestPurchaseContractDetail(id);
            PurchaseContractsDispatch({
                type: ACTION_TYPES.SET_CONTRACT_DETAIL,
                payload: result,
            });
        } catch (error) {
            console.log(error);
        }
    }

    async function loadFiles(id: number) {
        try {
            const result = await PortalAppService.requestPurchaseContractFiles(id);
            PurchaseContractsDispatch({
                type: ACTION_TYPES.SET_CONTRACT_FILES,
                payload: result,
            });
        } catch (error) {
            console.log(error);
        }
    }

    return {
        loadData,
        loadDetail,
        loadFiles
    };
}
